<csl-skeleton class="rounded-4xl mb-4 h-8 w-[200px]" />
<csl-skeleton class="mb-10 h-3 w-[380px] rounded-xl" />
<csl-skeleton class="mb-10 h-[148px] w-full rounded-3xl" />
<csl-skeleton class="mb-6 h-12 w-full rounded-xl" />
<div class="flex flex-wrap justify-between gap-y-6">
  <csl-skeleton class="h-12 w-[48%] rounded-xl" />
  <csl-skeleton class="h-12 w-[48%] rounded-xl" />
  <csl-skeleton class="h-12 w-[48%] rounded-xl" />
</div>
